import React from "react";
import circleImg from "assets/images/v2/Ellipse.svg";
import crossImg from "assets/images/v2/Close.svg";


const ToastCloseButton = ({
  closeToast,
}: {
  closeToast: (e: React.MouseEvent<HTMLElement>) => void;
}) => (
  <button className="toast-close-btn" onClick={closeToast}>
    <img src={circleImg} className="close-circle" alt="circle" />
    <img src={crossImg} className="close-cross" alt="close" />
  </button>
)

export default ToastCloseButton;
